import { render, staticRenderFns } from "./Gutter.vue?vue&type=template&id=1c12379a&scoped=true"
import script from "./Gutter.vue?vue&type=script&lang=ts"
export * from "./Gutter.vue?vue&type=script&lang=ts"
import style0 from "./Gutter.vue?vue&type=style&index=0&id=1c12379a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12379a",
  null
  
)

export default component.exports